export const testCalendar = {
  name: 'TestCalendar',
  months: [
    {
      name: 'one',
      days: 10,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'two',
      days: 10,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'three',
      days: 10,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'four',
      days: 10,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'five',
      days: 10,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'six',
      days: 10,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'seven',
      days: 10,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'eight',
      days: 10,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'nine',
      days: 10,
      leapDays: 50,
      leapPeriod: 5,
    },
    {
      name: 'ten',
      days: 10,
      leapDays: 100,
      leapPeriod: 10,
    },
  ],
  time: {
    minute: {
      name: 'Minute',
      plural: 'Minutes',
      duration: '60',
    },
    hour: {
      name: 'Hour',
      plural: 'Hours',
      duration: '3600',
    },
    day: {
      name: 'Day',
      plural: 'Days',
      duration: '86400',
    },
    month: {
      name: 'Month',
      plural: 'Months',
    },
    year: {
      name: 'Year',
      plural: 'Years',
      duration: '8640000',
    },
    decade: {
      name: 'Decade',
      plural: 'Decades',
      enabled: true,
      duration: '86400000',
    },
    century: {
      name: 'Century',
      plural: 'Centuries',
      enabled: true,
      duration: '864000000',
    },
    millenium: {
      name: 'Millenium',
      plural: 'Millenia',
      enabled: true,
      duration: '8640000000',
    },
    myriad: {
      name: 'Myriad',
      plural: 'Myriads',
      enabled: true,
      duration: '86400000000',
    },
    epoch: {
      name: 'Epoch',
      plural: 'Epochs',
      enabled: true,
      duration: '864000000000',
    },
    aeon: {
      name: 'Aeon',
      plural: 'Aeons',
      enabled: true,
      duration: '8640000000000',
    },
  },
  days: {
    showWeekDays: true,
    weekLength: 7,
    weekdays: [
      { name: 'Sunday', abbr: 'Sun', order: 0, weekend: true },
      { name: 'Monday', abbr: 'Mon', order: 1, weekend: false },
      { name: 'Tuesday', abbr: 'Tue', order: 2, weekend: false },
      { name: 'Wednesday', abbr: 'Wed', order: 3, weekend: false },
      { name: 'Thursday', abbr: 'Thu', order: 4, weekend: false },
      { name: 'Friday', abbr: 'Fri', order: 5, weekend: false },
      { name: 'Saturday', abbr: 'Sat', order: 6, weekend: true },
    ],
    globalHolidays: [{ name: 'New Years', day: 1, month: 0 }],
  },
};
